/**
 * Fiscal Period API Client
 */

import apiClient from './client';

export const getAllPeriods = async (filters = {}) => {
  const response = await apiClient.get('/fiscal-periods', { params: filters });
  return response.data;
};

export const getCurrentPeriod = async () => {
  const response = await apiClient.get('/fiscal-periods/current');
  return response.data;
};

export const createPeriodsForYear = async (year) => {
  const response = await apiClient.post('/fiscal-periods/generate', { year });
  return response.data;
};

export const openPeriod = async (periodId) => {
  const response = await apiClient.post(`/fiscal-periods/${periodId}/open`);
  return response.data;
};

export const closePeriod = async (periodId) => {
  const response = await apiClient.post(`/fiscal-periods/${periodId}/close`);
  return response.data;
};

// ============================================
// GLOBAL FISCAL SETTINGS API
// ============================================

/**
 * Get global fiscal settings
 * @param {string} module - 'retail' or 'wholesale'
 */
export const getGlobalSettings = async (module = 'retail') => {
  const response = await apiClient.get('/fiscal-periods/global-settings', { params: { module } });
  return response.data;
};

/**
 * Update global fiscal settings
 * @param {object} settings - Settings to update
 * @param {string} module - 'retail' or 'wholesale'
 */
export const updateGlobalSettings = async (settings, module = 'retail') => {
  const response = await apiClient.put('/fiscal-periods/global-settings', { ...settings, module });
  return response.data;
};

/**
 * Get current active period date range
 * @param {string} module - 'retail' or 'wholesale'
 */
export const getCurrentRange = async (module = 'retail') => {
  const response = await apiClient.get('/fiscal-periods/current-range', { params: { module } });
  return response.data;
};

/**
 * The period filter's periods for the signed-in person: today, every period with its dates,
 * the global period, whether the admin has locked it, and their saved choice per page
 * @param {string} module - 'retail' or 'wholesale'
 */
export const getPeriods = async (module = 'retail') => {
  const response = await apiClient.get('/fiscal-periods/periods', { params: { module } });
  return response.data;
};

/**
 * Save the person's period for a page
 * @param {object} choice - { period_key } or { start_date, end_date }
 */
export const savePeriodChoice = async (module, pageKey, choice) => {
  const response = await apiClient.put(`/fiscal-periods/periods/choices/${pageKey}`, {
    ...choice,
    module
  });
  return response.data;
};

/** The page goes back to the global period */
export const clearPeriodChoice = async (module, pageKey) => {
  const response = await apiClient.delete(`/fiscal-periods/periods/choices/${pageKey}`, {
    params: { module }
  });
  return response.data;
};

export default {
  getAllPeriods,
  getCurrentPeriod,
  createPeriodsForYear,
  openPeriod,
  closePeriod,
  getGlobalSettings,
  updateGlobalSettings,
  getCurrentRange,
  getPeriods,
  savePeriodChoice,
  clearPeriodChoice
};
